import Logo from '~/components/Logo';

export default Logo;
